import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { Clock, Star } from "lucide-react";
import { Reveal } from "@/components/reveal";
import SEO from "@/components/seo";
import awardsImg from "@assets/image_1775081264796.png";
import certificationsImg from "@assets/image_1775081279850.png";

const services = [
  {
    name: "VIP Program (Dog Walks & Visits)",
    duration: "Customizable visits, min 3 days/week",
    price: null,
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/ca936253-f0f0-46f7-a23f-80fbb38bc677/George.jpg",
    imgPosition: "left 20%",
    description: "This service is perfect for busy Tallahassee pet parents, or those who are physically unable to care for their pets for whatever reason. This service is customizable to you and your pets, can be any length or type of visit. We even have cat owners who have us visit for litter box change and clean outs. To join, you will be required to book a minimum of 3 days per week for at least one month (fair warning — most of our VIPs have been using us for several years!). You may choose 30 or 45 minute visits, alternate any combo of visits. We have limited availability from 11a-1p. Benefits of the program: priority when booking for vacations and holidays, no additional charge for recurring scheduling and automatic billing, late-notice booking availability.",
    highlight: true,
    cta: { label: "Learn about VIP", href: "/vip-program" },
    calendarLink: "https://calendly.com/tallylassiepets/interest-call-vip-program",
  },
  {
    name: "Express Care Visit",
    duration: "15 minutes",
    price: "Starts at $30",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/702b2008-18b8-43a1-b93d-6ae5088b56b6/IMG_3459.jpg",
    imgPosition: "center 25%",
    description: "This visit is perfect for pets who need a quick visit during the day for a let-out or home-check. All visits come with photos and comprehensive visit reports and 100% reliability booking. About half of our cat sitting clients book the express visit.",
  },
  {
    name: "Pet Pal Visit",
    duration: "30 minutes",
    price: "Starts at $35",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/1704215622943-1KXSQCE1QNTBWBVRME5Y/image-asset.jpeg",
    imgPosition: "center",
    description: "Our most popular service, including among VIPs! This is perfect for pets who need longer walks only, or who need a combination of feeding, short walks or let-outs, and home-checks. All visits come with photos and comprehensive visit reports. Providing any meds is always free.",
    popular: true,
    cta: { label: "Learn about Pet Pal Visits", href: "/pet-pal-visits" },
  },
  {
    name: "Pupventures",
    duration: "~90 minutes from pick up to drop off",
    price: "Starts at $95",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/864749a5-47e0-4938-ad8f-5b56b9ee2e2a/Lacy.jpeg",
    imgPosition: "center top",
    description: "This is perfect for the dog who needs to get out of the house! Especially ones who love car rides and do not have access to shade in their neighborhood. Your pup is safely secured and transported to a local park or greenway for one-on-one time (may be combined with friends for a playdate!).",
  },
  {
    name: "Bed & Breakfast",
    duration: "2-hour evening stay + 1-hour morning visit",
    price: "Starts at $150",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/2756e354-7f76-46b4-8e00-09e0e79b46bb/IMG_3120.jpg",
    imgPosition: "center 30%",
    description: "This visit is perfect for pets who need a little more attention from their sitters. Our Bed & Breakfast service includes a 2 hour evening stay with your pets from dinner to tuck-in, followed up with an hour visit in the morning. We keep the pet's routine consistent in your absence, and tend to household mail, lights, valet waste collection, scoop, package retrieval, and plant watering.",
    cta: { label: "Explore Pet Sitting", href: "/pet-sitting" },
  },
  {
    name: "Longer Love Visit",
    duration: "45 minutes",
    price: "Starts at $45",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/fb7a0c8a-6015-4c7e-aba0-aa08a882f904/IMG_2368.jpg",
    imgPosition: "center 55%",
    description: "Perfect for multiple pets, pets who need longer walks and feeds, or multiple boxes to scoop and places to clean. This is also a top choice for pets who may require additional attention. All visits come with photos and comprehensive visit reports.",
  },
  {
    name: "Dog Taxi",
    duration: "Transport to vet, boarder, groomer, etc.",
    price: "Starts at $25 in town",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/eac705e9-30e8-40b4-ac60-2550adae5805/priscilla-du-preez-YvdB5kLQPl0-unsplash.jpg",
    imgPosition: "left center",
    description: "Transportation to or from the vet, a boarder, family, daycare, training, the grandparents' house, etc. within reason and service range.",
  },
  {
    name: "House Check / Plant Care",
    duration: "Standalone or included with pet care",
    price: "Starts at $25",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/d92124c6-4686-49d7-aef0-f6c1661a1196/austin-wehrwein-EZERpkl3Lso-unsplash.jpg",
    imgPosition: "center",
    description: "Stand-alone service, or included with pet care services. Checking the premises, turning on/off lights as indicated, mail retrieval, garbage service, feeding and watering plants.",
  },
  {
    name: "Medication Administration",
    duration: "Included free with visits",
    price: "No extra charge",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/2d2fa1f0-8bee-48bf-8109-8957eef4667a/Meds.jpg",
    imgPosition: "center",
    description: "We can administer medications to your pets — oral, sub-Q, and IV — as needed. We do not charge extra for this service. Please speak with Carla directly at (850) 728-6220 about medications.",
  },
  {
    name: "Compassionate Care Visit",
    duration: "End-of-life or post-surgery care",
    price: "Regular visit pricing",
    img: "https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/15919705-f1ba-4b82-b574-1768c5607bdf/Vet.jpg",
    imgPosition: "left center",
    description: "A service offered by our Team Leads. Compassionate Care is for pets who are recovering from a surgery or who are at the end of life care. Visits are charged as a regular visit and there is no additional cost for medication admin, and we are able to consult with your vet as needed. Availability limited.",
  },
];

export default function Menu() {
  return (
    <div className="py-16 md:py-24">
      <SEO
        title="Services | Dog Walking, Pet Sitting & More"
        description="Services for Tallahassee Lassie Pet Sitting and Dog Walking, Let-outs, Dog hiking, dog walking, cat sitting, pet taxi, dog hikes, dog walks, pet sits, cat sits, dog walkers and pet sitters best of Tallahassee, best of Florida."
        path="/menu"
      />
      <div className="container mx-auto px-4">
        <Reveal>
          <div className="max-w-4xl mx-auto text-center mb-8">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-foreground mb-6">Our Services</h1>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">Tallahassee Lassie Pet Care offers award-winning daily or weekday dog walking.</p>
          </div>
        </Reveal>

        <div className="max-w-5xl mx-auto space-y-6">
          {services.map((service, i) => (
            <Reveal key={i} delay={i * 50}>
              <div
                className={`relative overflow-hidden border transition-all card-lift ${
                  service.highlight
                    ? "bg-primary/5 border-primary/20"
                    : "bg-card border-border/50 hover:border-primary/20"
                }`}
                style={{ borderRadius: "24px 0 24px 0" }}
              >
                {service.popular && (
                  <div className="absolute top-4 right-4 z-10 bg-secondary text-white text-xs font-bold px-3 py-1 uppercase tracking-wider rounded-full">
                    Most Popular
                  </div>
                )}
                {service.highlight && (
                  <div className="absolute top-4 right-4 z-10 bg-primary text-white text-xs font-bold px-3 py-1 uppercase tracking-wider rounded-full flex items-center gap-1">
                    <Star size={12} fill="currentColor" /> Premium
                  </div>
                )}

                <div className="flex flex-col sm:flex-row">
                  <div className="sm:w-36 md:w-44 flex-shrink-0 overflow-hidden">
                    <img
                      src={service.img}
                      alt={service.name}
                      className="w-full h-40 sm:h-full object-cover"
                      style={{ objectPosition: service.imgPosition ?? "center" }}
                    />
                  </div>

                  <div className="flex-1 p-6 md:p-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2 text-[14px]">
                      <h3 className="text-2xl font-serif font-bold">{service.name}</h3>
                      {service.price && (
                        <span className="font-bold text-primary whitespace-nowrap">
                          {service.price}
                        </span>
                      )}
                    </div>
                    <p className="text-sm text-muted-foreground font-medium mb-3 flex items-center gap-2">
                      <Clock size={14} /> {service.duration}
                    </p>
                    <p className="text-foreground/80 leading-relaxed">{service.description}</p>
                    {(service.cta || service.calendarLink) && (
                      <div className="mt-4 flex flex-wrap gap-3">
                        {service.cta && (
                          <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary hover:text-white">
                            <Link href={service.cta.href}>
                              {service.cta.label} &rarr;
                            </Link>
                          </Button>
                        )}
                        {service.calendarLink && (
                          <Button asChild className="bg-secondary hover:bg-secondary/90 text-white">
                            <a href={service.calendarLink} target="_blank" rel="noopener noreferrer">
                              Book an Interest Call
                            </a>
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="max-w-5xl mx-auto mt-16">
            <h2 className="text-3xl font-serif font-bold text-center mb-8">Good to Know</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-card border border-border/50 p-6" style={{ borderRadius: "16px 0 16px 0" }}>
                <h3 className="font-serif text-lg font-bold mb-2">Additional Pets</h3>
                <p className="text-foreground/80 text-sm">Up to 2 pets per visit. Each additional pet is $5.00 per visit.</p>
              </div>
              <div className="bg-card border border-border/50 p-6" style={{ borderRadius: "16px 0 16px 0" }}>
                <h3 className="font-serif text-lg font-bold mb-2">Extended Service Area</h3>
                <p className="text-foreground/80 text-sm">For extended service area visits: 30 mins / $40, 45 mins / $45.</p>
              </div>
              <div className="bg-card border border-border/50 p-6" style={{ borderRadius: "16px 0 16px 0" }}>
                <h3 className="font-serif text-lg font-bold mb-2">Holidays</h3>
                <p className="text-foreground/80 text-sm">We operate 365 days a year! As a benefit to our sitters, we charge $10/visit for all major holidays.</p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal>
          <div className="max-w-5xl mx-auto mt-16 text-center">
            <h2 className="text-3xl font-serif font-bold mb-3">Awards & Certifications</h2>
            <p className="text-muted-foreground mb-8">
              Tallahassee Lassie was named the Best in Florida and Best of Next Door 2020, 2021, 2022; and we are proud to be certified by the following entities.
            </p>
            <div className="mb-10">
              <img
                src={awardsImg}
                alt="Neighborhood Favorite Nextdoor 2020, 2021, 2022 and Voted Best of Florida 2022"
                className="max-w-lg mx-auto w-full"
              />
            </div>
            <div>
              <img
                src={certificationsImg}
                alt="Certified by Pet Sitters International (PSI), NAPPS, ProPetHero, and FetchFind"
                className="max-w-xl mx-auto w-full"
              />
            </div>
          </div>
        </Reveal>

        <Reveal>
          <div className="max-w-4xl mx-auto mt-16 bg-primary text-white p-12 text-center relative overflow-hidden" style={{ borderRadius: "32px 0 32px 0" }}>
            <h2 className="text-3xl font-serif font-bold mb-4">Ready to Get Started?</h2>
            <p className="text-xl text-white/90 max-w-2xl mx-auto mb-8">
              Create a free account to request a Meet & Greet and get matched with your perfect sitter.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button asChild size="lg" className="bg-white text-primary hover:bg-white/90 h-14 px-8 text-lg">
                <a href="https://www.timetopet.com/portal/tallylassiepets/create-account" target="_blank" rel="noopener noreferrer">
                  Create Account
                </a>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-white text-white hover:bg-white/10 h-14 px-8 text-lg">
                <Link href="/policies-rates">
                  View Policies
                </Link>
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
